import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PaymentModalPage } from './payment-modal.page';

const routes: Routes = [
  {
    path: '',
    component: PaymentModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
 declarations: [PaymentModalPage]
})
export class PaymentModalPageModule {}
